import {ApplicationRoute, LOCALIZED_ROUTE_TOKEN} from '../../craft/utils/application.route'

export const CLIENT_ROUTES = {
  CLIENT: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/client`), // hardcoded in app-routing user-default-route for tree shaking routes
  CLIENT_JOBS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/client/jobs`),
  CLIENT_JOBS_ALL: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/client/jobs/all`, 'all'),
  CLIENT_JOBS_IN_PROGRESS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/client/jobs/wip`, 'wip'),
  CLIENT_JOBS_COMPLETED: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/client/jobs/completed`, 'completed'),
  CLIENT_JOB_DETAILS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/client/jobs/:id`, 'jobs/:id'),
  CLIENT_JOB_DETAILS_OVERVIEW_TAB: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/client/jobs/:id/overview`,
    'overview',
  ),
  CLIENT_JOB_DETAILS_ASSIGNED_PROS_TAB: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/client/jobs/:id/pros`, 'pros'),
  CLIENT_JOB_DETAILS_CHATS_TAB: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/client/jobs/:id/chats`, 'chats'),
  CLIENT_JOB_DETAILS_CHATS_TAB_CONVERSATION: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/client/jobs/:id/chats/:roomId`,
    ':roomId',
  ),
  CLIENT_JOB_DETAILS_DETAILS_TAB: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/client/jobs/:id/details`, 'details'),
  CLIENT_JOB_DETAILS_SUPPORT_TAB: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/client/jobs/:id/support`, 'support'),
  CLIENT_JOB_ASSIGNED_PRO_DETAILS: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/client/jobs/:jobId/pro/:proId`,
    'jobs/:jobId/pro/:proId',
  ),
  CLIENT_SETTINGS: new ApplicationRoute(`/${LOCALIZED_ROUTE_TOKEN}/client/settings`),
  CLIENT_SETTINGS_BRING_A_FRIEND: new ApplicationRoute(
    `/${LOCALIZED_ROUTE_TOKEN}/client/settings/bring-a-friend`,
    'bring-a-friend',
  ),
}
